"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.987 7.997C4.8 5.713 6.613 3 9.997 3c3.44 0 5.243 2.705 5.008 5.01-.136 1.336-.748 2.265-1.313 3.022q-.128.172-.248.328c-.47.62-.82 1.084-.973 1.667a.7.7 0 0 1-.677.523H8.2a.7.7 0 0 1-.673-.508c-.08-.28-.231-.558-.453-.878-.141-.204-.285-.39-.443-.594a28 28 0 0 1-.342-.449c-.577-.777-1.189-1.748-1.302-3.124m3.697 4.153h.613V9.9L8.292 8.353a.7.7 0 1 1 1.175-.762l.53.817.53-.817a.7.7 0 1 1 1.175.762L10.697 9.9v2.25h.598c.273-.645.692-1.192 1.06-1.672l.215-.284c.523-.702.946-1.378 1.042-2.326.154-1.51-1.035-3.469-3.615-3.469-2.514 0-3.74 1.961-3.614 3.483.08.987.508 1.7 1.03 2.403q.134.18.29.38c.178.232.366.475.522.7.166.24.327.5.459.784m-1.11 2.497c0-.39.315-.706.705-.706h3.436c.39 0 .706.316.706.706 0 1.3-1.054 2.353-2.353 2.353h-.142a2.353 2.353 0 0 1-2.353-2.353m1.7.694c.17.16.4.259.652.259h.142a.95.95 0 0 0 .653-.259z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=LightbulbIcon20.js.map